import styled, { keyframes } from 'styled-components';
const pulse = keyframes `
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;
export const LoadingBlock = styled.div.attrs(() => ({
    role: 'status',
    'aria-live': 'polite',
})) `
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '14px'};
  border-radius: var(--border-r-stamp);
  opacity: 1;
  align-self: center;
  justify-self: center;

  background: #e0dddd;
  tr:hover & {
    background: #e8e6e6;
  }
  animation: ${pulse} 1s ease-in-out infinite;
`;
